import React from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../components/common/Text'

/**
 * mi6 has no badge/chip primitive, so this is a local one. Outlined rather than
 * filled: several can sit on one row, and filled pills would out-shout the
 * item title they describe.
 */
const PillView = styled(View)`
  border-width: 1px;
  border-color: ${props => props.theme.colors.border};
  border-radius: 11px;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 8px;
  padding-right: 8px;
  margin-right: 6px;
  align-self: center;
  flex-shrink: 0;
`

export const Pill = ({ children }: { children: React.ReactNode }) => (
  <PillView>
    <Text styles={{ fontSize: 11, lineHeight: 16 }}>{children}</Text>
  </PillView>
)

export default Pill
